(() => {
  const API_BASE = "https://your-backend-url.onrender.com";
  let localStream = null;
  let peerConnection = null;
  let signalingSocket = null;
  let mediaRecorder = null;
  let recordedChunks = [];

  const els = {
    sessionId: document.getElementById("ronSessionId"),
    displayName: document.getElementById("ronDisplayName"),
    localVideo: document.getElementById("ronLocalVideo"),
    remoteVideo: document.getElementById("ronRemoteVideo"),
    startCameraBtn: document.getElementById("ronStartCameraBtn"),
    shareScreenBtn: document.getElementById("ronShareScreenBtn"),
    joinSessionBtn: document.getElementById("ronJoinSessionBtn"),
    startRecordingBtn: document.getElementById("ronStartRecordingBtn"),
    stopRecordingBtn: document.getElementById("ronStopRecordingBtn"),
    downloadRecording: document.getElementById("ronDownloadRecording"),
    documentInput: document.getElementById("ronDocumentInput"),
    uploadDocumentBtn: document.getElementById("ronUploadDocumentBtn"),
    documentOutput: document.getElementById("ronDocumentOutput"),
    chatMessages: document.getElementById("ronChatMessages"),
    chatInput: document.getElementById("ronChatInput"),
    sendChatBtn: document.getElementById("ronSendChatBtn")
  };

  async function getStorefrontJwt() {
    const res = await fetch(`${API_BASE}/shopify/storefront-token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_name: els.displayName?.value || "Customer",
        session_id: els.sessionId?.value || ""
      })
    });

    if (!res.ok) throw new Error("Could not get session token");
    return res.json();
  }

  async function startCamera() {
    localStream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true
    });
    els.localVideo.srcObject = localStream;
  }

  async function shareScreen() {
    const screenStream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
      audio: true
    });

    const micStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    });

    const combined = new MediaStream();
    screenStream.getVideoTracks().forEach(track => combined.addTrack(track));
    micStream.getAudioTracks().forEach(track => combined.addTrack(track));

    localStream = combined;
    els.localVideo.srcObject = localStream;
  }

  async function joinSession() {
    const { access_token } = await getStorefrontJwt();
    const sessionId = els.sessionId.value.trim();
    const displayName = els.displayName.value.trim() || "Guest";

    signalingSocket = new WebSocket(
      `${API_BASE.replace("https", "wss").replace("http", "ws")}/ws/signaling/${sessionId}?token=${encodeURIComponent(access_token)}&name=${encodeURIComponent(displayName)}`
    );

    peerConnection = new RTCPeerConnection({
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
    });

    if (localStream) {
      localStream.getTracks().forEach(track => {
        peerConnection.addTrack(track, localStream);
      });
    }

    peerConnection.ontrack = event => {
      if (event.streams && event.streams[0]) {
        els.remoteVideo.srcObject = event.streams[0];
      }
    };

    peerConnection.onicecandidate = event => {
      if (event.candidate && signalingSocket?.readyState === WebSocket.OPEN) {
        signalingSocket.send(JSON.stringify({
          type: "ice-candidate",
          candidate: event.candidate
        }));
      }
    };

    signalingSocket.onmessage = async event => {
      const data = JSON.parse(event.data);

      if (data.type === "offer") {
        await peerConnection.setRemoteDescription(new RTCSessionDescription(data.offer));
        const answer = await peerConnection.createAnswer();
        await peerConnection.setLocalDescription(answer);
        signalingSocket.send(JSON.stringify({ type: "answer", answer }));
      }

      if (data.type === "answer") {
        await peerConnection.setRemoteDescription(new RTCSessionDescription(data.answer));
      }

      if (data.type === "ice-candidate" && data.candidate) {
        try {
          await peerConnection.addIceCandidate(new RTCIceCandidate(data.candidate));
        } catch (err) {
          console.error("ICE error", err);
        }
      }

      if (data.type === "chat-message") {
        appendChatMessage(data.sender, data.message, data.created_at);
      }
    };

    signalingSocket.onopen = async () => {
      const offer = await peerConnection.createOffer();
      await peerConnection.setLocalDescription(offer);
      signalingSocket.send(JSON.stringify({ type: "offer", offer }));
    };
  }

  function startRecording() {
    if (!localStream) {
      alert("Start camera or screen share first.");
      return;
    }

    const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
      ? "video/webm;codecs=vp9,opus"
      : "video/webm";

    recordedChunks = [];
    mediaRecorder = new MediaRecorder(localStream, { mimeType });

    mediaRecorder.ondataavailable = event => {
      if (event.data && event.data.size > 0) recordedChunks.push(event.data);
    };

    mediaRecorder.onstop = async () => {
      const blob = new Blob(recordedChunks, { type: mimeType });
      const url = URL.createObjectURL(blob);
      els.downloadRecording.href = url;
      els.downloadRecording.style.display = "inline-block";
      els.downloadRecording.textContent = "Download Recording";

      const formData = new FormData();
      formData.append("file", new File([blob], "ron-recording.webm", { type: mimeType }));
      formData.append("session_id", els.sessionId.value.trim());

      const { access_token } = await getStorefrontJwt();

      const res = await fetch(`${API_BASE}/api/recordings/upload`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${access_token}` },
        body: formData
      });

      const data = await res.json();
      console.log("Recording uploaded", data);
    };

    mediaRecorder.start(1000);
  }

  function stopRecording() {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
    }
  }

  async function uploadDocument() {
    const file = els.documentInput.files[0];
    if (!file) {
      alert("Choose a document first.");
      return;
    }

    const { access_token } = await getStorefrontJwt();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("session_id", els.sessionId.value.trim());

    const res = await fetch(`${API_BASE}/api/documents/upload`, {
      method: "POST",
      headers: { "Authorization": `Bearer ${access_token}` },
      body: formData
    });

    const data = await res.json();
    els.documentOutput.textContent = JSON.stringify(data, null, 2);
  }

  function appendChatMessage(sender, message, createdAt) {
    const row = document.createElement("div");
    row.style.marginBottom = "10px";
    row.innerHTML = `<strong>${sender}</strong><br>${message}<br><small>${createdAt || ""}</small>`;
    els.chatMessages.appendChild(row);
    els.chatMessages.scrollTop = els.chatMessages.scrollHeight;
  }

  function sendChatMessage() {
    const message = els.chatInput.value.trim();
    if (!message || !signalingSocket || signalingSocket.readyState !== WebSocket.OPEN) return;
    signalingSocket.send(JSON.stringify({ type: "chat-message", message }));
    els.chatInput.value = "";
  }

  els.startCameraBtn?.addEventListener("click", startCamera);
  els.shareScreenBtn?.addEventListener("click", shareScreen);
  els.joinSessionBtn?.addEventListener("click", joinSession);
  els.startRecordingBtn?.addEventListener("click", startRecording);
  els.stopRecordingBtn?.addEventListener("click", stopRecording);
  els.uploadDocumentBtn?.addEventListener("click", uploadDocument);
  els.sendChatBtn?.addEventListener("click", sendChatMessage);
})();